module.exports = __webpack_public_path__ + "img/img-petins.c5f51a04.png";